import * as React from 'react';
import MQ from 'react-responsive';
import { MOBILE_MIN_WIDTH, TABLET_MIN_WIDTH } from '../utils';
var MediaQuery = function (_a) {
    var minWidth = _a.minWidth, maxWidth = _a.maxWidth, children = _a.children;
    return (React.createElement(MQ, { values: { width: window.innerWidth }, minWidth: minWidth === 'mobile' ? +MOBILE_MIN_WIDTH + 1 : minWidth === 'tablet' ? +TABLET_MIN_WIDTH + 1 : null, maxWidth: maxWidth === 'mobile' ? MOBILE_MIN_WIDTH : maxWidth === 'tablet' ? TABLET_MIN_WIDTH : null }, children));
};
export default MediaQuery;
